import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import ToggleInput from "../../components/shared/Input/ToggleInput";
import OptionsInput from "../../components/shared/Input/OptionsInput";
import Interpret from "../../components/shared/Localization/Interpret";
import { APP_CONSTANTS } from "../../models/constants/AppConstants";

class DeveloperConfiguration extends Component {
	render({className, style}) {
		return (
			<section className={combineClasses("developer-configuration", className)} style={style}>
				<h1 className={"separator"}><Interpret id={"settings.developer"}/></h1>

				<ToggleInput
					label={"No idle redirect"}
					labelTranslated={true}
					value={!!localStorage.getItem("noRedirect")}
					onModify={(enable) => {
						if(enable) {
							localStorage.setItem("noRedirect", 1)
						}
						else {
							localStorage.removeItem("noRedirect");
						}
						window.dispatchEvent(new Event(APP_CONSTANTS.LOCAL_STORAGE_NO_REDIRECT_EVENT_NAME));
						this.forceUpdate();
					}}
				/>

				<ToggleInput
					label={"Log idle timeout change"}
					labelTranslated={true}
					value={!!localStorage.getItem("logIdleTimeoutChange")}
					onModify={(enable) => {
						if(enable) {
							localStorage.setItem("logIdleTimeoutChange", 1);
						}
						else {
							localStorage.removeItem("logIdleTimeoutChange");
						}
						this.forceUpdate();
					}}
				/>

				<ToggleInput
					label={"Show hidden sections"}
					labelTranslated={true}
					value={!!localStorage.getItem("showHiddenSections")}
					onModify={(enable) => {
						if(enable) {
							localStorage.setItem("showHiddenSections", 1);
						}
						else {
							localStorage.removeItem("showHiddenSections");
						}
						this.forceUpdate();
					}}
				/>

				<OptionsInput
					options={[
						{text: "off", value: undefined},
						{text: "resolve", textTranslated: true, value: "resolve", accentOnActive: "success"},
						{text: "reject", textTranslated: true, value: "reject", accentOnActive: "error"},
					]}
					label={"Simulate box opening"}
					labelTranslated={true}
					value={localStorage.getItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_BOX_OPENING)}
					onModify={(value) => {
						if(value !== undefined) {
							localStorage.setItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_BOX_OPENING, value);
						}
						else {
							localStorage.removeItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_BOX_OPENING);
						}
						this.forceUpdate();
					}}
				/>

				<OptionsInput
					options={[
						{text: "off", value: undefined},
						{text: "resolve", textTranslated: true, value: "resolve", accentOnActive: "success"},
						{text: "reject", textTranslated: true, value: "reject", accentOnActive: "error"},
					]}
					label={"Simulate rent wizard session creation"}
					labelTranslated={true}
					value={localStorage.getItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_WIZARD_SESSION_CREATION)}
					onModify={(value) => {
						if(value !== undefined) {
							localStorage.setItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_WIZARD_SESSION_CREATION, value);
						}
						else {
							localStorage.removeItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_WIZARD_SESSION_CREATION);
						}
						this.forceUpdate();
					}}
				/>

				<OptionsInput
					options={[
						{text: "off", value: undefined},
						{text: "resolve", textTranslated: true, value: "resolve", accentOnActive: "success"},
						{text: "reject", textTranslated: true, value: "reject", accentOnActive: "error"},
					]}
					label={"Simulate payment process"}
					labelTranslated={true}
					value={localStorage.getItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_PAYMENT_PROCESS)}
					onModify={(value) => {
						if(value !== undefined) {
							localStorage.setItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_PAYMENT_PROCESS, value);
						}
						else {
							localStorage.removeItem(APP_CONSTANTS.LOCAL_STORAGE_SIMULATE_PAYMENT_PROCESS);
						}
						this.forceUpdate();
					}}
				/>
			</section>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,
		}
	}
}

export default DeveloperConfiguration;
